import React, { Children, memo, useContext } from 'react';
import classNames from 'classnames';
import { Col } from '../grid';
import ConfigContext from '../config-provider/ConfigContext';
import ListContext from './ListContext';
const ListMeta = function ListMeta(props) {
    const { prefixCls: customizePrefixCls, className, avatar, title, description, ...others } = props;
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('list', customizePrefixCls);
    const classString = classNames(`${prefixCls}-item-meta`, className);
    const content = (React.createElement("div", { className: `${prefixCls}-item-meta-content` },
        title && React.createElement("h4", { className: `${prefixCls}-item-meta-title` }, title),
        description && React.createElement("div", { className: `${prefixCls}-item-meta-description` }, description)));
    return (React.createElement("div", Object.assign({}, others, { className: classString }),
        avatar && React.createElement("div", { className: `${prefixCls}-item-meta-avatar` }, avatar),
        (title || description) && content));
};
ListMeta.displayName = 'ListMeta';
export const Meta = memo(ListMeta);
function getGrid(grid, t) {
    return grid[t] && Math.floor(24 / grid[t]);
}
const ListItem = function ListItem(props) {
    const { grid, getPrefixCls } = useContext(ListContext);
    const { prefixCls: customizePrefixCls, children, actions, extra, className, renderCheckBox, ...others } = props;
    const prefixCls = getPrefixCls('list', customizePrefixCls);
    const classString = classNames(`${prefixCls}-item`, className, {
        [`${prefixCls}-selection`]: renderCheckBox,
        [`${prefixCls}-selected`]: renderCheckBox && renderCheckBox.isChecked,
    });
    const metaContent = [];
    const otherContent = [];
    Children.forEach(children, (element) => {
        if (element && element.type && element.type === Meta) {
            metaContent.push(element);
        }
        else {
            otherContent.push(element);
        }
    });
    const contentClassString = classNames(`${prefixCls}-item-content`, {
        [`${prefixCls}-item-content-single`]: metaContent.length < 1,
    });
    const content = otherContent.length > 0 ? React.createElement("div", { className: contentClassString }, otherContent) : null;
    let actionsContent;
    if (actions && actions.length > 0) {
        const actionsContentItem = (action, i) => (React.createElement("li", { key: `${prefixCls}-item-action-${i}` },
            action,
            i !== actions.length - 1 && React.createElement("em", { className: `${prefixCls}-item-action-split` })));
        actionsContent = (React.createElement("ul", { className: `${prefixCls}-item-action` }, actions.map((action, i) => actionsContentItem(action, i))));
    }
    const extraContent = (React.createElement("div", { className: `${prefixCls}-item-extra-wrap` },
        React.createElement("div", { className: `${prefixCls}-item-main` },
            metaContent,
            content,
            actionsContent),
        React.createElement("div", { className: `${prefixCls}-item-extra` }, extra)));
    const mainContent = grid ? (React.createElement(Col, { span: getGrid(grid, 'column'), xs: getGrid(grid, 'xs'), sm: getGrid(grid, 'sm'), md: getGrid(grid, 'md'), lg: getGrid(grid, 'lg'), xl: getGrid(grid, 'xl'), xxl: getGrid(grid, 'xxl') },
        React.createElement("div", Object.assign({}, others, { className: classString }),
            extra && extraContent,
            !extra && metaContent,
            !extra && content,
            !extra && actionsContent))) : (React.createElement("div", Object.assign({}, others, { className: classString }),
        renderCheckBox && renderCheckBox.element(),
        React.createElement(React.Fragment, null,
            extra && extraContent,
            !extra && metaContent,
            !extra && content,
            !extra && actionsContent)));
    return mainContent;
};
ListItem.displayName = 'ListItem';
ListItem.Meta = Meta;
export default ListItem;
